import React from 'react';
import { BrainIcon, FlameIcon, HeartIcon } from 'lucide-react';
export const Mentality: React.FC = () => {
  const pillars = [{
    icon: <BrainIcon className="w-8 h-8" data-id="element-189" />,
    title: 'Disciplina Diaria',
    description: 'Convertir la disciplina en estilo de vida. Cada día es una oportunidad para mejorar un 1% más.',
    quote: '"Talento sin trabajo duro no significa nada."'
  }, {
    icon: <HeartIcon className="w-8 h-8" data-id="element-190" />,
    title: 'Resiliencia',
    description: 'Transformar la crítica en combustible. Las dificultades son solo oportunidades disfrazadas.',
    quote: '"Tu amor me hace fuerte, tu odio me hace imparable."'
  }, {
    icon: <FlameIcon className="w-8 h-8" data-id="element-191" />,
    title: 'Hambre Competitiva',
    description: 'Convertir la presión en placer. Nunca estar satisfecho, siempre buscando el siguiente nivel.',
    quote: '"Siempre quiero más. Más goles, más trofeos."'
  }];
  return <section className="py-20" data-id="element-192">
      <div className="text-center mb-16" data-id="element-193">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-194">
          Mentalidad de Campeón
        </h2>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-195">
          Muchos admiran su talento. Pocos aplican su forma de pensar.
        </p>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto mt-4" data-id="element-196">
          Esto no es entretenimiento. Es un espejo. Un reflejo de cómo opera
          alguien que convirtió la crítica en combustible, la disciplina en
          estilo de vida, la presión en placer.
        </p>
      </div>
      <div className="max-w-md mx-auto mb-16" data-id="element-197">
        <div className="relative aspect-[3/4] rounded-xl overflow-hidden border-2 border-[#E0B84C]/30 shadow-xl" data-id="element-198">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tmn8NmbzeAa2nuo7AH3o1S/Screenshot_2025-10-02_at_1.36.33_PM.png" alt="Rutina de Disciplina - Planificador de Mentalidad" className="w-full h-full object-cover" data-id="element-199" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-200"></div>
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-center" data-id="element-201">
            <p className="text-white font-bold text-lg" data-id="element-202">Rutina 110%</p>
            <p className="text-[#E0B84C] text-sm" data-id="element-203">Planificador de Mentalidad</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-204">
        {pillars.map((pillar, index) => <div key={index} className="p-8 bg-gradient-to-b from-gray-900 to-black border border-yellow-600/20 rounded-xl relative overflow-hidden group" data-id="element-205">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-600/10 rounded-full blur-2xl transform -translate-x-1/2 -translate-y-1/2 group-hover:bg-yellow-600/20 transition-all duration-500" data-id="element-206"></div>
            <div className="relative z-10" data-id="element-207">
              <div className="w-16 h-16 bg-black/50 rounded-full flex items-center justify-center mb-6 border border-yellow-600/30 text-yellow-500" data-id="element-208">
                {pillar.icon}
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-209">{pillar.title}</h3>
              <p className="text-gray-400 mb-6" data-id="element-210">{pillar.description}</p>
              <div className="p-4 bg-black/50 border-l-4 border-yellow-500 rounded" data-id="element-211">
                <p className="italic text-yellow-500" data-id="element-212">{pillar.quote}</p>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-16 text-center" data-id="element-213">
        <p className="text-xl text-yellow-500 font-medium" data-id="element-214">
          Este no es un ebook sobre un ídolo. Es un manual sobre lo que puedes
          activar en ti mismo.
        </p>
      </div>
    </section>;
};